// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skills-summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  background: linear-gradient(180deg, #0a0f1c 0%, #111827 100%);
  color: #ffffff;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  padding-bottom: 4rem;
}

/* ===== Header ===== */
.skills-summary header {
  display: flex;
  flex-direction: column;
  align-items: center; /* centers title + contact info */
  text-align: center;
  position: relative; /* allows absolute positioning for button */
  width: 90%;
  max-width: 900px;
  margin: 4rem auto 2rem;
  animation: fadeIn 1.2s ease-in-out;
}

/* Print button left-aligned */
.skills-summary .prt-button {
  position: absolute;
  left: 0;
  top: 0;
}

/* Header text styling */
.skills-summary h2 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #ffffff; /* pure white for title */
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
}

.skills-summary .contact-info {
  font-size: 1rem;
  color: #ffffff; /* pure white for contact line */
  margin-bottom: 0.5rem;
}

.skills-summary .contact-info a {
  color: #ffffff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.skills-summary .contact-info a:hover {
  color: #00aeef;
  text-decoration: underline;
}

/* ===== Skills Section ===== */
.skills-section {
  width: 90%;
  max-width: 1000px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);
  backdrop-filter: blur(6px);
  animation: slideUp 1.2s ease-in-out;
  line-height: 1.6;
  color: #e0e0e0;
}

.skills-section ul {
  list-style-type: none;
  padding-left: 0;
}

.skills-section li {
  margin-bottom: 0.8rem;
  font-size: 1rem;
}

/* ===== Competencies ===== */
.competencies {
  width: 90%;
  max-width: 1000px;
  margin-top: 2rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);
  backdrop-filter: blur(6px);
  animation: slideUp 1.4s ease-in-out;
}

.competencies h3 {
  font-size: 1.6rem;
  color: #00aeef;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 174, 239, 0.4);
  padding-bottom: 0.5rem;
}

.competency-zone {
  margin-bottom: 2rem;
}

.competency-zone h4 {
  font-size: 1.2rem;
  color: #00aeef;
  margin-bottom: 0.5rem;
}

.competency-zone ul {
  list-style-type: none;
  padding-left: 0;
}

.competency-zone li {
  margin-bottom: 0.6rem;
  color: #cfd8dc;
}

/* ===== Footer ===== */
.skills-summary footer {
  text-align: center;
  margin-top: 3rem;
  font-size: 0.9rem;
  color: #b0bec5;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;
}

/* ===== Animations ===== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .skills-summary h2 {
    font-size: 1.8rem;
  }

  .skills-section,
  .competencies {
    padding: 1.5rem;
  }

  .skills-summary .prt-button {
    top: 0.4rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SkillsSummary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,6DAA6D;EAC7D,cAAc;EACd,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,iCAAiC;EACtD,kBAAkB;EAClB,kBAAkB,EAAE,2CAA2C;EAC/D,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc,EAAE,yBAAyB;EACzC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,gCAAgC;EAChD,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".skills-summary {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  background: linear-gradient(180deg, #0a0f1c 0%, #111827 100%);\n  color: #ffffff;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  padding-bottom: 4rem;\n}\n\n/* ===== Header ===== */\n.skills-summary header {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* centers title + contact info */\n  text-align: center;\n  position: relative; /* allows absolute positioning for button */\n  width: 90%;\n  max-width: 900px;\n  margin: 4rem auto 2rem;\n  animation: fadeIn 1.2s ease-in-out;\n}\n\n/* Print button left-aligned */\n.skills-summary .prt-button {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n/* Header text styling */\n.skills-summary h2 {\n  font-size: 2.2rem;\n  font-weight: 700;\n  color: #ffffff; /* pure white for title */\n  letter-spacing: 0.5px;\n  margin-bottom: 0.5rem;\n}\n\n.skills-summary .contact-info {\n  font-size: 1rem;\n  color: #ffffff; /* pure white for contact line */\n  margin-bottom: 0.5rem;\n}\n\n.skills-summary .contact-info a {\n  color: #ffffff;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.skills-summary .contact-info a:hover {\n  color: #00aeef;\n  text-decoration: underline;\n}\n\n/* ===== Skills Section ===== */\n.skills-section {\n  width: 90%;\n  max-width: 1000px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);\n  backdrop-filter: blur(6px);\n  animation: slideUp 1.2s ease-in-out;\n  line-height: 1.6;\n  color: #e0e0e0;\n}\n\n.skills-section ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.skills-section li {\n  margin-bottom: 0.8rem;\n  font-size: 1rem;\n}\n\n/* ===== Competencies ===== */\n.competencies {\n  width: 90%;\n  max-width: 1000px;\n  margin-top: 2rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);\n  backdrop-filter: blur(6px);\n  animation: slideUp 1.4s ease-in-out;\n}\n\n.competencies h3 {\n  font-size: 1.6rem;\n  color: #00aeef;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid rgba(0, 174, 239, 0.4);\n  padding-bottom: 0.5rem;\n}\n\n.competency-zone {\n  margin-bottom: 2rem;\n}\n\n.competency-zone h4 {\n  font-size: 1.2rem;\n  color: #00aeef;\n  margin-bottom: 0.5rem;\n}\n\n.competency-zone ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.competency-zone li {\n  margin-bottom: 0.6rem;\n  color: #cfd8dc;\n}\n\n/* ===== Footer ===== */\n.skills-summary footer {\n  text-align: center;\n  margin-top: 3rem;\n  font-size: 0.9rem;\n  color: #b0bec5;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: 1.5rem;\n}\n\n/* ===== Animations ===== */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .skills-summary h2 {\n    font-size: 1.8rem;\n  }\n\n  .skills-section,\n  .competencies {\n    padding: 1.5rem;\n  }\n\n  .skills-summary .prt-button {\n    top: 0.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
